import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { select, Store } from '@ngrx/store';
import { IAppState } from '../../store/app.state';
import { selectCentrosList } from '../../store/selectors/centros.selectors'
import { ICentro, ICreateCentro, IUpdateCentro } from '../../interfaces/centros.interface';
import { Actions, ofType } from '@ngrx/effects';
import { DatePipe } from '@angular/common';
import { map, tap } from 'rxjs/operators';
import { DownloadService } from 'src/app/services/download.service';
import { Table } from 'primeng/table';
import {
  CreateCentro, CreateCentroSuccess, DeleteCentro, DeleteCentroSuccess,
  GetCentros, UpdateCentro, UpdateCentroSuccess
} from '../../store/actions/centros.actions';
import { selectProgramasList } from 'src/app/store/selectors/programas.selectors';
import { GetProgramas } from 'src/app/store/actions/programas.actions';
import { selectFormulariosList } from 'src/app/store/selectors/formularios.selectors';
import { CreateFormularioCentro, CreateFormularioCentroSuccess, GetFormularios } from 'src/app/store/actions/formularios.actions';
import { ExportExcelService } from 'src/app/services/export-excel.service';

@Component({
  selector: 'app-centros',
  templateUrl: './centros.component.html',
  styleUrls: ['./centros.component.scss']
})
export class CentrosComponent implements OnInit, OnDestroy {
  @ViewChild('dt', { static: false }) table: Table;

  centros = this.store$.pipe(
    select(selectCentrosList),
    map(centros => centros.map(centro => {
      this.centrosExcel.push(centro)
      return {
        ...centro,
        fecha_activacion: this.datePipe.transform(centro.fecha_activacion, 'dd/MM/yyyy'),
      }
    }))
  );

  programas = this.store$.pipe(
    select(selectProgramasList),
    map(programas => programas.map(programa => {
      return { label: programa.programa_social, value: programa.programa_social }
    }))
  );

  formularios = this.store$.pipe(
    select(selectFormulariosList),
    map(formularios => formularios.map(formulario => {
      return { label: formulario.titulo, value: formulario.form }
    }))
  );

  createFormulariosSubscription = this.actions$.pipe(
    ofType(CreateFormularioCentroSuccess),
  ).subscribe(_ => {
    this.spinner = false;
  });

  cols: any[];
  exportColumns: any[];
  mode = '';
  header = '';
  displayForm = false;
  displayMap = false;
  mapOptions: any;
  mapOverlays = [];
  formCentro: FormGroup;
  displayFormulario = false;
  formularioAsignado: any;
  formularioAsignadoData: any;
  spinner = false;
  centrosExcel = [];
  dataForExcel = [];

  dias = [
    { label: 'Lunes', value: 'Lunes' },
    { label: 'Martes', value: 'Martes' },
    { label: 'Miercoles', value: 'Miercoles' },
    { label: 'Jueves', value: 'Jueves' },
    { label: 'Viernes', value: 'Viernes' },
    { label: 'Sabado', value: 'Sabado' },
  ];

  servicios = [
    { label: 'Internet', value: 'Internet' },
    { label: 'Agua', value: 'Agua' },
    { label: 'Luz', value: 'Luz' },
    { label: 'Gas', value: 'Gas' },
  ];

  mobiliarios = [
    { label: 'Computadoras', value: 'Computadoras' },
    { label: 'Hornos', value: 'Hornos' },
    { label: 'Estufas', value: 'Estufas' },
    { label: 'Refrigerador', value: 'Refrigerador' },
    { label: 'Escritorios', value: 'Escritorios' },
    { label: 'Mesas', value: 'Mesas' },
    { label: 'Otros', value: 'Otros' }
  ];

  downloadItems = [
    { label: 'CSV', command: () => { this.downloadService.exportCSV('centros', this.table) } },
    { label: 'PDF', command: () => { this.downloadService.exportPdf('centros', this.table) } },
  ];

  formSubmitSubscription = this.actions$.pipe(
    ofType(UpdateCentroSuccess, DeleteCentroSuccess, CreateCentroSuccess),
    tap(_ => {
      this.store$.dispatch(GetCentros());
      this.displayForm = false;
    })
  ).subscribe();

  constructor(
    private formBuilder: FormBuilder,
    private confirmationService: ConfirmationService,
    private store$: Store<IAppState>,
    private actions$: Actions,
    public downloadService: DownloadService,
    private datePipe: DatePipe,
    private ete: ExportExcelService
  ) {
    this.formCentro = this.formBuilder.group({
      _id: new FormControl(''),
      programa: new FormControl(''),
      nombre: new FormControl(''),
      descripcion: new FormControl(''),
      direccion: new FormControl(''),
      latitud: new FormControl(''),
      longitud: new FormControl(''),
      fecha_activacion: new FormControl(''),
      contacto: new FormControl(''),
      servicios: new FormControl(''),
      mobiliario: new FormControl(''),
      aulas: new FormControl(''),
      dias: new FormControl(''),
      horario: new FormControl('')
    });
  }

  ngOnInit() {
    this.cols = [
      { field: 'nombre', header: 'Nombre', exportable: true },
      { field: 'programa', header: 'Programa Social', exportable: true },
      { field: 'fecha_activacion', header: 'Fecha Activacion', exportable: true },
      { field: 'contacto', header: 'Contacto', exportable: true },
      { field: 'ubicacion', header: 'Ubicacion', exportable: false },
      { field: 'acciones', header: 'Acciones', exportable: false }
    ];

    this.store$.dispatch(GetCentros());
    this.store$.dispatch(GetProgramas());
    this.store$.dispatch(GetFormularios());
  }

  ngOnDestroy() {
    this.formSubmitSubscription.unsubscribe();
  }

  editarCentro(centro): void {
    this.mode = 'EDITAR'
    this.header = 'Editar Centro Comunitario';
    this.formCentro.patchValue({
      ...centro
    });
    this.formCentro.enable();

    this.displayForm = true;
  }

  verCentro(centro): void {
    this.mode = 'DETALLE'
    this.header = 'Detalle Centro Comunitario'
    console.log(centro);
    this.formCentro.patchValue({
      ...centro
    });
    this.formCentro.disable();

    this.displayForm = true;
  }

  agregarCentro() {
    this.mode = 'AGREGAR'
    this.header = 'Agregar Centro Comunitario'
    this.formCentro.patchValue({
      _id: '',
      programa: '',
      nombre: '',
      descripcion: '',
      direccion: '',
      latitud: '',
      longitud: '',
      fecha_activacion: '',
      contacto: '',
      servicios: '',
      mobiliario: '',
      aulas: '',
      dias: '',
      horario: ''
    })
    this.formCentro.enable();

    this.displayForm = true;
  }

  borrarCentro(centro: ICentro) {
    this.confirmationService.confirm({
      header: 'Borrar Centro Comunitario',
      message: `¿Seguro que quiere borrar el centro comunitario '${centro.nombre}'?`,
      acceptLabel: 'Aceptar',
      rejectVisible: false,
      accept: async () => {
        this.store$.dispatch(DeleteCentro({ id: centro._id }))
      }
    });
  }

  verMapa(centro: ICentro) {
    this.mapOptions = {
      center: { lat: +centro.latitud, lng: +centro.longitud },
      zoom: 15
    }

    this.mapOverlays = [
      new google.maps.Marker({ position: { lat: +centro.latitud, lng: +centro.longitud }, title: centro.nombre }),
    ];

    this.displayMap = true;
  }

  submitForm() {
    const form: ICentro = this.formCentro.getRawValue();

    if (this.mode === 'AGREGAR') {
      const payload: ICreateCentro = {
        ...form,
      }

      this.store$.dispatch(CreateCentro({ centro: payload }));
    } else if (this.mode === 'EDITAR') {
      const payload: IUpdateCentro = {
        ...form,
      }

      this.store$.dispatch(UpdateCentro({ id: form._id, centro: payload }));
    }

    return;
  }

  verFormularios(centro: ICentro) {
    this.header = 'Formularios';
    this.displayFormulario = true;
    this.formularioAsignadoData = { form: '', nombre: centro.nombre || [] };
  }

  asignarFormulario() {
    this.spinner = true;
    const form = { ...this.formularioAsignadoData }
    form.form = this.formularioAsignado;
    this.store$.dispatch(CreateFormularioCentro({ formulariosAsignados: form }));
  }

  exportToExcel() {
    this.dataForExcel = [];

    const uniqueArray = this.centrosExcel.filter((value, index) => {
      const _value = JSON.stringify(value);
      return index === this.centrosExcel.findIndex(obj => {
        return JSON.stringify(obj) === _value;
      });
    });

    uniqueArray.forEach((row: any) => {
      const insert = { ...row, dias: row.dias.join(), servicios: row.servicios.join(), mobiliario: row.mobiliario.join() }
      this.dataForExcel.push(Object.values(insert))
    })

    const headers = {
      id: '',
      programa: '',
      nombre: '',
      descripcion: '',
      direccion: '',
      latitud: '',
      longitud: '',
      'fecha de activacion': '',
      contacto: '',
      servicios: '',
      mobiliario: '',
      aulas: '',
      dias: '',
      horario: ''
    }

    const reportData = {
      title: 'Centros Comunitarios',
      data: this.dataForExcel,
      headers: Object.keys(headers)
    }

    this.ete.exportExcel(reportData, false);
  }
}
